function IsMobile(){
    return window.matchMedia && window.matchMedia("(max-width: 600px)").matches;
}

export default IsMobile;